<template>
  <HomeFooter />
</template>

<script>
import HomeFooter from "@/views/pages/public/home/home-footer.vue";

export default {
  components: {
    HomeFooter,
  },
};
</script>
